<template>
  <view class="detail">
    <view class="main">
      <view class="top">
        <p class="title font-16">
          活动蛋糕体验
        </p>
        <p class="font-11">
          预约人数<span class="golden">2</span>人
        </p>
        <p class="time color-999 font-11">
          2020-6-28 19:28
        </p>
        <image
          class="qrcode"
          :src="noImg"
          mode="aspectFill"
        />
        <p class="notes">
          兑换码：1234 1234 12
        </p>
      </view>
      <view class="info">
        <p class="title font-15">
          订单信息
        </p>
        <p class="tr font-11">
          <span>订单编号</span>
          <span class="value">12345</span>
        </p>
        <p class="tr font-11">
          <span>订单编号</span>
          <span class="value">12345</span>
        </p>
      </view>
      <view class="info">
        <p class="title font-15">
          订单信息
        </p>
        <p class="tr font-11">
          <span>订单编号</span>
          <span class="value">12345</span>
        </p>
        <p class="tr font-11">
          <span>订单编号</span>
          <span class="value">12345</span>
        </p>
      </view>
    </view>
  </view>
</template>

<script>
export default {
	data(){
		return{
			noImg:require('static/logo.png')
		};
	}
};
</script>

<style lang="less" scoped>
.detail{
	overflow: hidden;
	height:100vh;
	background:#E3B979;
	.main{
		width:690upx;
		margin:30upx;
		background:#FFF;
		border-radius: 10upx;
		box-sizing: border-box;
		padding:30upx;
		p{
			margin-bottom:14upx;
		}
	}
	.top{
		padding-bottom: 40upx;
		.title{
			font-weight: 500;
			margin-bottom: 40upx;
		}
		.golden{
			color:#B38251;
		}
		.notes{
			text-align: center;
			margin-top:40upx;
			font-weight: 500;
		}
	}
	.qrcode{
		width:230upx;
		height:230upx;
		display: block;
		margin:30upx auto;
	}
	.info{
		border-top:1px #D8D8D8 solid;
		padding:28upx 0;
		.title{
			font-weight: 500;
			margin-bottom:30upx;
		}
		.tr{
			display: flex;
			.value{
				margin-left:30upx;
			}
		}
	}
}
</style>
